import { isMobileResolution } from '../../../../../../contrib/utils';
import { IStateDispatchActions } from '../TeeSheetCreator.context';

const isMobile = isMobileResolution();

export type IOnSelectSeat = (group: number) => (seat: number) => () => void;

export const onSelectSeat: IStateDispatchActions<IOnSelectSeat> = (
  _,
  dispatch
) => group => seat => () => {
  if (isMobile) {
    dispatch({ type: 'set', value: { attribute: 'searchValue', value: '' } });
    dispatch({ type: 'set', value: { attribute: 'modalOpen', value: true } });
  }
  dispatch({ type: 'set', value: { attribute: 'selectedGroup', value: group } });
  dispatch({ type: 'set', value: { attribute: 'selectedSeat', value: seat } });
};
